(function(){
  var country = window.MSK_COUNTRY || '';
  if (country !== 'IT') return;

  // ── Auto-langue ──────────────────────────────────────────────────────────
  var LANG_KEY = 'msk_lang';
  if (!localStorage.getItem(LANG_KEY)) {
    function setLang() {
      if (typeof mskSetLang === 'function') { mskSetLang('it'); }
      else { setTimeout(setLang, 50); }
    }
    setLang();
  }

  // ── Données Italie ───────────────────────────────────────────────────────
  var d = {
    landingNames: [
      "Marco R. — Roma","Giulia M. — Milano","Luca F. — Napoli",
      "Sofia B. — Torino","Alessandro C. — Firenze","Valentina R. — Bologna",
      "Matteo S. — Venezia","Chiara L. — Palermo"
    ],
    photoReviews: [
      {t:'"Ricevuto in perfetto stato! Molto ben imballato con la carta MySportKits. 100% consigliato!"', n:'Marco R. — Roma'},
      {t:'"Le TN sono fantastiche, taglia perfetta. L\'attesa ne è valsa la pena."', n:'Giulia M. — Milano'},
      {t:'"Qualità top per il prezzo! Esattamente come nelle foto. Molto soddisfatto."', n:'Luca F. — Napoli'},
      {t:'"Bellissime! Taglia perfetta, imballaggio curato con biglietto di ringraziamento."', n:'Sofia B. — Torino'},
      {t:'"Taglia 42, super comode. Il colore esattamente come mi aspettavo."', n:'Alessandro C. — Firenze'},
      {t:'"Ordinate per mia figlia (36), è contentissima! Sneaker impeccabili."', n:'Valentina R. — Bologna'},
      {t:'"TN nere/gialle di grande qualità. Negozio affidabile, già al mio 3° ordine!"', n:'Matteo S. — Venezia'},
      {t:'"2° acquisto da MySportKits, sempre al top! Bellissime scarpe bianche."', n:'Chiara L. — Palermo'},
      {t:'"Ricevuto in ottimo stato. Il mio vicino ha ordinato dopo aver visto le mie!"', n:'Lorenzo T. — Genova'}
    ],
    textReviews: [
      {s:'★★★★★', t:'Qualità incredibile per il prezzo. Consegna un po\' lunga ma ne vale assolutamente la pena. Lo consiglio!', a:'Marco R.', l:'Roma'},
      {s:'★★★★★', t:'Molto soddisfatto del mio ordine, le scarpe sono bellissime. Taglia corretta. Ho già ordinato un secondo paio.', a:'Giulia M.', l:'Milano'},
      {s:'★★★★★', t:'Rapporto qualità-prezzo imbattibile. I miei amici pensano che siano originali e costano 5 volte meno. Assistenza clienti ottima.', a:'Luca F.', l:'Napoli'},
      {s:'★★★★☆', t:'Paio bellissimo, fedele alla descrizione. Tolgo una stella per i tempi un po\' lunghi, ma la qualità è garantita.', a:'Sofia B.', l:'Torino'},
      {s:'★★★★★', t:'Secondo ordine da MySportKits. Sempre seri. Le TN sono perfette, finiture curate, suola robusta.', a:'Alessandro C.', l:'Firenze'},
      {s:'★★★★★', t:'Regalo per mio figlio, è pazzo di gioia! Taglia giusta grazie alla guida. Imballaggio curato. Esperienza eccellente.', a:'Valentina R.', l:'Bologna'}
    ],
    photoTag:   '📸 Recensioni verificate con foto',
    photoTitle: 'HANNO RICEVUTO IL LORO ORDINE',
    badge:      '✓ Verificato'
  };

  var descText = 'Sneaker di qualità premium. Vestibilità confortevole, materiali durevoli. Spedizione mondiale in 7-14 giorni lavorativi.';

  function fixDesc() {
    var el = document.querySelector('.product-desc');
    if (!el || el.getAttribute('data-local-desc-done')) return;
    el.setAttribute('data-local-desc-done', '1');
    el.textContent = descText;
  }

  function fixLandingNames() {
    var rvNames = document.querySelectorAll('.reviews-track.row-1 .rv-name');
    if (!rvNames.length) rvNames = document.querySelectorAll('.rv-name');
    rvNames.forEach(function(el, i) {
      el.textContent = d.landingNames[i % d.landingNames.length];
    });
  }

  function fixPhotoGrid() {
    var grid = document.getElementById('photo-reviews-grid');
    if (!grid || grid.getAttribute('data-local-done') || grid.getAttribute('data-uk-photo-done')) return;
    grid.setAttribute('data-local-done', '1');
    var cards = grid.querySelectorAll('.rv-photo-card');
    cards.forEach(function(card, i) {
      var pr = d.photoReviews[i % d.photoReviews.length];
      var textEl = card.querySelector('.rv-text');
      var nameEl = card.querySelector('.rv-name');
      var badgeEl = card.querySelector('.rv-badge');
      if (textEl) textEl.textContent = pr.t;
      if (nameEl) nameEl.textContent = pr.n;
      if (badgeEl) badgeEl.textContent = d.badge;
    });
    var pt = document.getElementById('photo-rv-tag');
    if (pt) pt.textContent = d.photoTag;
    var ph = document.getElementById('photo-rv-title');
    if (ph) ph.textContent = d.photoTitle;
  }

  function fixTextReviews() {
    var grid = document.querySelector('.reviews-grid');
    if (!grid || grid.getAttribute('data-local-rv-done')) return;
    grid.setAttribute('data-local-rv-done', '1');
    var html = '';
    d.textReviews.forEach(function(r) {
      html += '<div class="review-card">'
            + '<div class="review-stars">' + r.s + '</div>'
            + '<div class="review-text">"' + r.t + '"</div>'
            + '<div class="review-author">' + r.a + ' <span class="review-location">— ' + r.l + '</span></div>'
            + '</div>';
    });
    grid.innerHTML = html;
  }

  function run() {
    fixDesc();
    fixLandingNames();
    fixPhotoGrid();
    fixTextReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 500);
})();
